import { Plug } from "@phosphor-icons/react";

type TileViewEmptyStateProps = {
    message: string;
};

const TileViewEmptyState = ({ message }: TileViewEmptyStateProps) => {
    return (
        <div className="flex justify-center items-center p-6 bg-surface-light-1 rounded-xl dashed-disabled-card-border">
            <div className="flex items-center gap-2">
                <Plug className="text-surface-dark-5" />
                <p className="text-surface-dark-5">{message}</p>
            </div>
        </div>
    );
};

export default TileViewEmptyState;
